export enum AnalyticsEvent {
  AuthClientChanged = "auth_client_changed",
  CallOutError = "commuinication_call_out_error",
  CmdKFileUploadFileError = "cmd_k_file_upload_file_error",
  CmdKOpened = "cmd_k_opened",
  CmdKVisibilityChanged = "cmd_k_visibility_changed",
  KeyboardShortcutTriggered = "keyboard_shortcut_triggered",
  SelectedTemplateToGenerateResumeApplicationLink = "selected_template_to_generate_resume_application_link",
  TimeAgoToFullTimeUsed = "time_ago_to_full_time_used",
  TwilioDisconnectRetriesLimit = "twilio_disconnect_retries_limit",
  TwilioError = "twilio_error",
  TwilioIncomingCall = "twilio_incoming_call",
  TwilioOutgoingCall = "twilio_outgoing_call",
  WflDataOrchestrationRun = "workflow_live_data_orchestration_run",
  WflDealActivityTypeChanged = "workflow_live_deal_activity_type_changed",
  WflDealEmailThreadOpened = "workflow_live_deal_email_thread_opened",
  WflDealKilled = "workflow_live_deal_killed",
  WflDealStageChanged = "workflow_live_stage_changed",
  WflStageViewed = "workflow_live_stage_viewed",
  WflWorkflowLoaded = "workflow_live_workflow_loaded",

  // Inbox Events
  InboxViewChanged = "inbox_view_changed",
  InboxThreadOpened = "inbox_thread_opened",
  InboxThreadClosed = "inbox_thread_closed",
  InboxThreadSwitched = "inbox_thread_switched",

  // Data Orchestration Events
  DataOrchestrationTemplateViewed = "data_orchestration_template_viewed",
  DataOrchestrationTemplateCreated = "data_orchestration_template_created",
  DataOrchestrationTemplateSaved = "data_orchestration_template_saved",
  DataOrchestrationTemplateDeleted = "data_orchestration_template_deleted",
  DataOrchestrationBlockAdded = "data_orchestration_block_added",
  DataOrchestrationBlockDeleted = "data_orchestration_block_deleted",
  DataOrchestrationConditionAdded = "data_orchestration_condition_added",
  DataOrchestrationConditionUpdated = "data_orchestration_condition_updated",
  DataOrchestrationConditionDeleted = "data_orchestration_condition_deleted",

  // Scorecards Events
  ScorecardsTabChanged = "scorecards_tab_changed",
  ScorecardsViewChanged = "scorecards_view_changed",
  ScorecardCreated = "scorecard_created",
  ScorecardRun = "scorecard_run",
  ScorecardBlockAdded = "scorecard_block_added",
  ScorecardRunTriggered = "scorecard_run_triggered",
  ScorecardGroupRunTriggered = "scorecard_group_run_triggered",

  // Custom Webhooks Events
  CustomWebhookCreated = "custom_webhook_created",
  CustomWebhookUpdated = "custom_webhook_updated",
  CustomWebhookDeleted = "custom_webhook_deleted",
  CustomWebhookTriggered = "custom_webhook_triggered",

  // Command Bar Events
  CmdKAgentTriggered = "cmd_k_agent_triggered",
  CmdKSearchPerformed = "cmd_k_search_performed",
  CmdKModeChanged = "cmd_k_mode_changed",

  // Contract Builder Events
  ContractBuilderViewed = "contract_builder_viewed",
  ContractTemplateCreated = "contract_template_created",
  ContractTemplateEdited = "contract_template_edited",
  ContractTemplateDeleted = "contract_template_deleted",

  // Communication Bar Events
  CommunicationEmailSent = "communication_email_sent",
  CommunicationSmsSent = "communication_sms_sent",
  CommunicationCallInitiated = "communication_call_initiated",
  CommunicationTaskCreated = "communication_task_created",
  QuickActionsOpened = "quick_actions_opened",
  QuickActionsCallInitiated = "quick_actions_call_initiated",
  QuickActionsSmsSent = "quick_actions_sms_sent",

  // Email/SMS Templates Events
  EmailTemplateCreated = "email_template_created",
  EmailTemplateUpdated = "email_template_updated",
  EmailTemplateDeleted = "email_template_deleted",
  EmailTemplateUsed = "email_template_used",
  SmsTemplateCreated = "sms_template_created",
  SmsTemplateUpdated = "sms_template_updated",
  SmsTemplateDeleted = "sms_template_deleted",
  SmsTemplateUsed = "sms_template_used",
}
